/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminAuditTrailItemDto { 
    /**
     * Type of admin action
     */
    type: AdminAuditTrailItemDto.TypeEnum;
    /**
     * Admin user ID who performed the action
     */
    adminUserId: string;
    /**
     * Timestamp when action was performed
     */
    timestamp: string;
    /**
     * Action details (varies by type)
     */
    details: object;
}
export namespace AdminAuditTrailItemDto {
    export type TypeEnum = 'refund' | 'status_update' | 'note';
    export const TypeEnum = {
        Refund: 'refund' as TypeEnum,
        StatusUpdate: 'status_update' as TypeEnum,
        Note: 'note' as TypeEnum
    };
}


